import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { ClipboardList } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import SapaQuestionnaireImage from 'assets/home/sapa-questionnaire.webp';
import { Banner } from 'components/ui/Banner';
import { ROUTES } from 'constants/routes';

export const SapaCard = ({ className }: { className?: string }): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.SERVICES);
  const navigate = useNavigate();

  const handleOpenEmotionalChat = (): void => {
    navigate(ROUTES.SAPA_CHAT);
  };

  return (
    <Banner
      className={cn('[&_p]:whitespace-pre-line [&_img]:h-56', className)}
      title={t('SapaCard.heading')}
      icon={ClipboardList}
      buttonProps={{
        variant: 'secondary',
        label: t('SapaCard.cta'),
        onClick: handleOpenEmotionalChat,
      }}
      description={`${t('SapaCard.body')}\n${t('SapaCard.info.body')}`}
      image={SapaQuestionnaireImage}
    />
  );
};
